import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=39e516ed&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=39e516ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e516ed",
  null
  
)

export default component.exports